import cn from 'classnames'
import Avatar from 'ext-ui/components/Avatar/Avatar'
import React, { ComponentProps, ReactElement } from 'react'
import { useSelector } from 'react-redux'
import {
  selectAppName,
  selectBrandName,
} from 'src/redux/selectors/session.selectors'

import style from './BrandLogoIcon.style'

type BrandLogoIconProps = {
  className?: string
  knockout?: boolean
  size?: number
} & Omit<ComponentProps<'div'>, 'children'>

function BrandLogoIcon(props: BrandLogoIconProps): ReactElement {
  const brandName = useSelector(selectBrandName)
  const appName = useSelector(selectAppName)
  const { className = '', size, ...rest } = props

  return (
    <Avatar
      className={cn('BrandLogoIcon', className)}
      css={style}
      imageSrc={`https://brand-assets.paywithextend.com/${brandName}/MarkLogo${props.knockout ? 'Knockout' : ''}.svg`}
      fallback={appName}
      variant="outlined"
      size={size}
      {...rest}
    />
  )
}

export default BrandLogoIcon
